import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import Carousel from "react-bootstrap/Carousel";

import "./banner.css";

import banner1 from "./assets/Carousel/banner-1.jpeg";
import banner2 from "./assets/Carousel/banner-2.jpg";
import banner3 from "./assets/Carousel/banner-3.jpg";

const Banner = () => {
  return (
    <>
      <Carousel
        style={{
          width: "100%",
          // textAlign: "center",
          marginTop: "10px",
          marginBottom: 0,
        }}
      >
        <Carousel.Item interval={1000}>
          <img src={banner1} style={{ width: "100%", height: "50%" }}></img>
          {/* <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption> */}
        </Carousel.Item>
        <Carousel.Item interval={500}>
          <img src={banner2} style={{ width: "100%", height: "50%" }}></img>
          {/* <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption> */}
        </Carousel.Item>
        <Carousel.Item>
          <img src={banner3} style={{ width: "100%", height: "50%" }}></img>
          {/* <Carousel.Caption>
            <h3>Third slide label</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption> */}
        </Carousel.Item>
      </Carousel>
    </>
  );
};
export default Banner;
